var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg404 = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 208,
  viewBox: "562 159 327 208",
  width: 327,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M767.05 361.356c0 2.848-22.2 5.156-49.586 5.156-27.385 0-49.586-2.308-49.586-5.156s22.2-5.156 49.586-5.156 49.587 2.308 49.587 5.156",
  fill: "#0100ff",
  opacity: 0.08
}), /*#__PURE__*/React.createElement("path", {
  d: "M613 325h23v-42h19.2v-20.6H636v-42h-23v42h-28V185h-23v98h51zm56.6-46.6c0 26.4 19.4 49 49 49 30 0 49.4-22.6 49.4-49v-46.8c0-26.4-19.4-49-49.4-49-29.6 0-49 22.6-49 49zm75.4 0c0 15.4-10.4 28.4-26.4 28.4-15.8 0-26-13-26-28.4v-46.8c0-15.4 10.2-28.4 26-28.4 16 0 26.4 13 26.4 28.4zm95.8 46.6h23v-42H883v-20.6h-19.2v-42h-23v42h-28V185h-23v98h51z",
  fill: "#4241ff",
  opacity: 0.177
}), /*#__PURE__*/React.createElement("path", {
  d: "M755.18 250.237h-5.893v-14.943h5.893c4.175 0 7.572-4.261 7.572-9.5v-12.378h11.91v12.379c0 13.478-8.74 24.442-19.482 24.442",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M755.18 250.237h-5.893v-14.943h5.893c4.175 0 7.572-4.261 7.572-9.5v-12.378h11.91v12.379c0 13.478-8.74 24.442-19.482 24.442z",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M774.662 207.477h-5.967v-22.813a2.984 2.984 0 0 1 5.967 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M774.662 207.477h-5.967v-22.813a2.984 2.984 0 0 1 5.967 0z",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "m768.695 200.66-5.276-5.384v-6.414a2.638 2.638 0 1 1 5.276 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m768.695 200.66-5.276-5.384v-6.414a2.638 2.638 0 1 1 5.276 0z",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "m768.695 200.66-5.276-5.384v-6.414a2.638 2.638 0 1 1 5.276 0z",
  fill: "#0100ff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M774.662 221.145v-15.14l-.006-3.584c-.056-5.515-4.554-9.986-10.082-9.986-3.55 0-6.878 1.9-8.686 4.96a3.052 3.052 0 0 0 5.251 3.106 3.957 3.957 0 0 1 3.435-1.963 3.991 3.991 0 0 1 3.987 3.987 3.991 3.991 0 0 1-3.987 3.987 3.957 3.957 0 0 1-3.435-1.963 3.05 3.05 0 1 0-5.252 3.105 10.142 10.142 0 0 0 6.849 4.781l-.007.006v8.704",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M774.662 221.145v-15.14l-.006-3.584c-.056-5.515-4.554-9.986-10.082-9.986-3.55 0-6.878 1.9-8.686 4.96a3.052 3.052 0 0 0 5.251 3.106 3.957 3.957 0 0 1 3.435-1.963 3.991 3.991 0 0 1 3.987 3.987 3.991 3.991 0 0 1-3.987 3.987 3.957 3.957 0 0 1-3.435-1.963 3.05 3.05 0 1 0-5.252 3.105 10.142 10.142 0 0 0 6.849 4.781l-.007.006v8.704",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("g", {
  fill: "#0100ff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M766.53 211.846v13.643c0 5.81-3.77 10.539-8.4 10.539h-2.388c4.142-.645 7.361-5.08 7.361-10.45v-13.732h3.426z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M752.346 247.246c1.29 0 2.552-.158 3.773-.46 8.943-2.21 15.71-12.124 15.71-23.982v-41.131c0-.172-.024-.337-.052-.5a2.98 2.98 0 0 1 2.287 2.893v41.13c0 12.833-7.924 23.388-17.955 24.369a15.76 15.76 0 0 1-1.527.074",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M753.286 250.238h3.32v-14.944h-3.32z",
  opacity: 0.15
})), /*#__PURE__*/React.createElement("path", {
  d: "M681.536 250.237h5.893v-14.943h-5.893c-4.175 0-7.572-4.261-7.572-9.5v-12.378h-11.91v12.379c0 13.478 8.74 24.442 19.482 24.442",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.536 250.237h5.893v-14.943h-5.893c-4.175 0-7.572-4.261-7.572-9.5v-12.378h-11.91v12.379c0 13.478 8.74 24.442 19.482 24.442z",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M662.054 207.477h5.966v-22.813a2.984 2.984 0 0 0-5.967 0v22.813z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M662.054 207.477h5.966v-22.813a2.984 2.984 0 0 0-5.967 0v22.813z",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "m668.02 200.66 5.276-5.384v-6.414a2.638 2.638 0 0 0-5.276 0z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m668.02 200.66 5.276-5.384v-6.414a2.638 2.638 0 0 0-5.276 0z",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "m668.02 200.66 5.276-5.384v-6.414a2.638 2.638 0 0 0-5.276 0z",
  fill: "#0100ff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M662.054 221.145v-15.14l.005-3.584c.056-5.515 4.555-9.986 10.082-9.986 3.55 0 6.878 1.9 8.686 4.96a3.052 3.052 0 0 1-5.251 3.106 3.957 3.957 0 0 0-3.435-1.963 3.991 3.991 0 0 0-3.987 3.987 3.991 3.991 0 0 0 3.987 3.987 3.957 3.957 0 0 0 3.435-1.963 3.05 3.05 0 1 1 5.252 3.105 10.142 10.142 0 0 1-6.849 4.781l.007.006v8.704",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M662.054 221.145v-15.14l.005-3.584c.056-5.515 4.555-9.986 10.082-9.986 3.55 0 6.878 1.9 8.686 4.96a3.052 3.052 0 0 1-5.251 3.106 3.957 3.957 0 0 0-3.435-1.963 3.991 3.991 0 0 0-3.987 3.987 3.991 3.991 0 0 0 3.987 3.987 3.957 3.957 0 0 0 3.435-1.963 3.05 3.05 0 1 1 5.252 3.105 10.142 10.142 0 0 1-6.849 4.781l.007.006v8.704",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M670.186 211.846v13.643c0 5.81 3.768 10.539 8.4 10.539h2.388c-4.143-.645-7.362-5.08-7.362-10.45v-13.732z",
  fill: "#0100ff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M684.37 247.246a15.67 15.67 0 0 1-3.773-.46c-8.944-2.21-15.71-12.124-15.71-23.982v-41.131c0-.172.023-.337.051-.5a2.98 2.98 0 0 0-2.286 2.893v41.13c0 12.833 7.923 23.388 17.954 24.369.504.049 1.013.074 1.528.074",
  fill: "#0100ff",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M680.109 250.238h3.32v-14.944h-3.32z",
  fill: "#0100ff",
  opacity: 0.15
}), /*#__PURE__*/React.createElement("path", {
  d: "M689.23 321.714v32.083l-4.998 3.98c-1.02.813-.446 2.458.858 2.458h8.37a4.421 4.421 0 0 0 4.004-2.546l15.757-33.628",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M689.23 321.714v32.083l-4.998 3.98c-1.02.813-.446 2.458.858 2.458h8.37a4.421 4.421 0 0 0 4.004-2.546l15.757-33.628",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M704.007 343.731c-8.405-.563-15.047-7.56-15.047-16.11v-6.243h16.14v20.012",
  fill: "#0100ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M746.529 321.714v32.083l4.999 3.98c1.02.813.446 2.458-.858 2.458h-8.371a4.421 4.421 0 0 1-4.004-2.546l-7.536-16.085-8.22-17.543",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M746.529 321.714v32.083l4.999 3.98c1.02.813.446 2.458-.858 2.458h-8.371a4.421 4.421 0 0 1-4.004-2.546l-7.536-16.085-8.22-17.543",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M731.77 343.74c8.474-.49 15.195-7.519 15.195-16.118v-6.244h-16.142v20.552",
  fill: "#0100ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M730.75 329.719h-25.6c-12.124 0-21.952-9.83-21.952-21.958V201.355c0-12.127 9.828-21.957 21.951-21.957h25.601c12.123 0 21.951 9.83 21.951 21.957v106.406c0 12.127-9.828 21.958-21.95 21.958",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M730.75 329.719h-25.6c-12.124 0-21.952-9.83-21.952-21.958V201.355c0-12.127 9.828-21.957 21.951-21.957h25.601c12.123 0 21.951 9.83 21.951 21.957v106.406c0 12.127-9.828 21.958-21.95 21.958z",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M726.747 323.057h-17.595c-10.278 0-18.61-8.334-18.61-18.615v-99.767c0-10.281 8.332-18.616 18.61-18.616h17.595c10.278 0 18.61 8.335 18.61 18.616v99.767c0 10.28-8.332 18.615-18.61 18.615",
  fill: "#0100ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M726.747 323.057h-17.595c-10.278 0-18.61-8.334-18.61-18.615v-99.767c0-10.281 8.332-18.616 18.61-18.616h17.595c10.278 0 18.61 8.335 18.61 18.616v99.767c0 10.28-8.332 18.615-18.61 18.615z",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.676
})), /*#__PURE__*/React.createElement("path", {
  d: "M718.358 163.448c-10.386 0-18.806 8.422-18.806 18.811V325.81c0 10.389 8.42 18.811 18.806 18.811 10.385 0 18.805-8.422 18.805-18.81V182.258c0-10.39-8.42-18.81-18.805-18.81",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M718.358 163.448c-10.386 0-18.806 8.422-18.806 18.811V325.81c0 10.389 8.42 18.811 18.806 18.811 10.385 0 18.805-8.422 18.805-18.81V182.258c0-10.39-8.42-18.81-18.805-18.81z",
  stroke: "#0100ff",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.092 169.433c-8.874 0-16.068 7.196-16.068 16.072v137.059c0 8.876 7.194 16.072 16.068 16.072s16.068-7.196 16.068-16.072V185.505c0-8.876-7.194-16.072-16.068-16.072",
  fill: "#0100ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M713.493 230.513c0 5.742-4.823 5.742-4.823 11.484 0 5.744 4.823 5.744 4.823 11.487s-4.823 5.743-4.823 11.486 4.823 5.743 4.823 11.486c0 5.744-4.823 5.744-4.823 11.487 0 5.744 4.823 5.744 4.823 11.488s-4.823 5.744-4.823 11.488m20.901-80.406c0 5.742-4.823 5.742-4.823 11.484 0 5.744 4.823 5.744 4.823 11.487s-4.823 5.743-4.823 11.486 4.823 5.743 4.823 11.486c0 5.744-4.823 5.744-4.823 11.487 0 5.744 4.823 5.744 4.823 11.488s-4.823 5.744-4.823 11.488m-3.216-80.406c0 5.742-4.823 5.742-4.823 11.484 0 5.744 4.823 5.744 4.823 11.487s-4.823 5.743-4.823 11.486 4.823 5.743 4.823 11.486c0 5.744-4.823 5.744-4.823 11.487 0 5.744 4.823 5.744 4.823 11.488s-4.823 5.744-4.823 11.488",
  stroke: "#0100ff",
  strokeLinecap: "round",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.745 203.872c-.59 0-1.068.479-1.068 1.068v.405c0 1.23-1 2.232-2.23 2.232s-2.23-1.001-2.23-2.232v-.405a1.07 1.07 0 0 0-1.068-1.068 1.07 1.07 0 0 0-1.068 1.068v.405a4.372 4.372 0 0 0 4.366 4.368 4.372 4.372 0 0 0 4.365-4.368v-.405c0-.589-.478-1.068-1.067-1.068",
  fill: "#0100ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.745 203.872c-.59 0-1.068.479-1.068 1.068v.405c0 1.23-1 2.232-2.23 2.232s-2.23-1.001-2.23-2.232v-.405a1.07 1.07 0 0 0-1.068-1.068 1.07 1.07 0 0 0-1.068 1.068v.405a4.372 4.372 0 0 0 4.366 4.368 4.372 4.372 0 0 0 4.365-4.368v-.405c0-.589-.478-1.068-1.067-1.068z",
  stroke: "#0100ff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M730.919 199.675a.808.808 0 0 0-.808.807v.307c0 .93-.756 1.687-1.686 1.687s-1.686-.757-1.686-1.687v-.307a.808.808 0 0 0-1.615 0v.307a3.305 3.305 0 0 0 3.301 3.302 3.305 3.305 0 0 0 3.301-3.302v-.307a.808.808 0 0 0-.807-.807",
  fill: "#0100ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M730.919 199.675a.808.808 0 0 0-.808.807v.307c0 .93-.756 1.687-1.686 1.687s-1.686-.757-1.686-1.687v-.307a.808.808 0 0 0-1.615 0v.307a3.305 3.305 0 0 0 3.301 3.302 3.305 3.305 0 0 0 3.301-3.302v-.307a.808.808 0 0 0-.807-.807z",
  stroke: "#0100ff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M710.777 199.675a.808.808 0 0 0-.807.807v.307c0 .93-.757 1.687-1.686 1.687a1.69 1.69 0 0 1-1.687-1.687v-.307a.808.808 0 0 0-1.614 0v.307a3.305 3.305 0 0 0 3.301 3.302c1.82 0 3.3-1.481 3.3-3.302v-.307a.808.808 0 0 0-.807-.807",
  fill: "#0100ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M710.777 199.675a.808.808 0 0 0-.807.807v.307c0 .93-.757 1.687-1.686 1.687a1.69 1.69 0 0 1-1.687-1.687v-.307a.808.808 0 0 0-1.614 0v.307a3.305 3.305 0 0 0 3.301 3.302c1.82 0 3.3-1.481 3.3-3.302v-.307a.808.808 0 0 0-.807-.807z",
  stroke: "#0100ff",
  strokeWidth: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M678.742 160.894v7.343",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M678.742 160.894v7.343",
  stroke: "#0100ff",
  strokeLinecap: "round",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M675.072 164.565h7.34",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M675.072 164.565h7.34",
  stroke: "#0100ff",
  strokeLinecap: "round",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M758.742 160.894v7.343",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M758.742 160.894v7.343",
  stroke: "#0100ff",
  strokeLinecap: "round",
  strokeWidth: 1.676
}), /*#__PURE__*/React.createElement("path", {
  d: "M755.072 164.565h7.34",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M755.072 164.565h7.34",
  stroke: "#0100ff",
  strokeLinecap: "round",
  strokeWidth: 1.676
}))));
export default Svg404;